import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { showSnackBar } from "../utils/commonServices";
import { createDeviceInfoApi,  getDeviceInfoApi, getGuestEventDetailsApi, registerGuestApi,  } from "../services/api";
import { setGuestReviewState } from "../redux/guestSlice";
import { setTheme } from "../redux/customThemeSlice";



export default ()=> {
 
  const dispatch = useDispatch();
  const commonReducer = useSelector(state=> state.root.commonReducer)
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('c')
  const guestReducer = useSelector(state=> state.guestReducer)
  const deviceInfoSlug = localStorage.getItem('device_info_slug')

  const createDeviceInfo = (value, callback ) => {
    // dispatch(setGuestReviewState({is_loading: true}))
    const payload ={
      system : value?.system
    }
    createDeviceInfoApi(payload) 
    .then((response) => {
      // dispatch(setGuestReviewState({is_loading: false}))
      if(response?.data?.http_code === 200){
        localStorage.setItem("device_info_slug", response?.data?.data?.slug);
        // console.log(response?.data?.data?.slug)
        getDeviceInfo({slug: response?.data?.data?.slug, mode: value?.mode})
        // getGuestEventDetails({slug:code, guest_user_id: response?.data?.data?.guest_user_id }, callback)
        // dispatch(setGuestReviewState({guest_user_id: response.data.data.guest_user_id}))
     }
    })
    .catch((error) => {
     if(error) {
      const errorObject = error?.response?.data;
      showSnackBar(dispatch, errorObject);
      // dispatch(setGuestReviewState({is_loading: false, show_guest_revision_page: false}))
    }
    });
    }

    const getDeviceInfo = (payload, callback ) => {
      // dispatch(setGuestReviewState({is_loading: true}))
      getDeviceInfoApi({slug: payload?.slug}) 
      .then((response) => {
        // dispatch(setGuestReviewState({is_loading: false}))
        if(response?.data?.http_code === 200){
          dispatch(setGuestReviewState({guest_reviewer_page_loading : false, guest_uploader_page_loading: false}))

          if((Array.isArray(response?.data?.data?.guest_user) && response?.data?.data?.guest_user?.length === 0) || (typeof response?.data?.data?.guest_user === 'object' && response?.data?.data?.guest_user !== null && Object.keys(response?.data?.data?.guest_user)?.length === 0)
          ){
            dispatch(setGuestReviewState({ guest_user_details_popup: true, guest_user_id: response?.data?.data?.guest_user?.id}))
          }else{
            
            dispatch(setGuestReviewState({ guest_user_id: response?.data?.data?.guest_user?.id, guest_name:response?.data?.data?.guest_user?.name}))
            getGuestEventDetails({slug:code, guest_user_id: response?.data?.data?.guest_user?.id, mode: payload?.mode }, callback, true)
          }
       }
      })
      .catch((error) => {
       if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
        dispatch(setGuestReviewState({is_loading: false, show_guest_revision_page: false}))
      }
      });
      }


    const registerGuestUser = (value, callback ) => {
      dispatch(setGuestReviewState({is_loading: true}))
      
      // Extract mode and use it locally, don't send it to API
      const { mode, ...restValue } = value;
      const payload ={
        ...restValue,
        slug: code,
        device_info_slug: deviceInfoSlug,
        isUploader: mode === 'upload'
      }
   
      registerGuestApi(payload) 
      .then((response) => {
        dispatch(setGuestReviewState({is_loading: false}))
        if(response?.data?.http_code === 200){
          // console.log(response.data.data.guest_user_id)
          dispatch(setGuestReviewState({
            guest_user_id: response.data.data.guest_user_id,
            guest_name: value?.name // Set the name immediately from input
          }))
          getDeviceInfo({slug: deviceInfoSlug, mode: mode})
          getGuestEventDetails({slug:code, guest_user_id: response?.data?.data?.guest_user_id, mode: mode }, callback, true)
        //  callback && callback()
          // getGuestEventDetails({slug: code, guest_user_id: 1})
       }
      })
      .catch((error) => {
       if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
        dispatch(setGuestReviewState({is_loading: false, show_guest_revision_page: false}))
      }
      });
      }


      const getGuestEventDetails = (payload, callback, isLoader ) => {
        isLoader && dispatch(setGuestReviewState({get_event_details_loading: true}))
        
        // Extract mode and use it locally, don't send it to API
        const { mode, ...restPayload } = payload;
        const apiPayload = {
          ...restPayload,
          ...(mode === 'upload' && { isUploader: true })
        }
        
        getGuestEventDetailsApi(apiPayload) 
        .then((response) => {
          isLoader && dispatch(setGuestReviewState({get_event_details_loading: false}))
          if(response?.data?.http_code === 200){
            // console.log(response.data)
            callback && callback()
            dispatch(setGuestReviewState({is_loading: false, event_details: response?.data?.data , logs: response?.data?.data?.logs}))
            dispatch(setTheme({primary:  response?.data?.data?.theme?.primary_colour, secondary: response?.data?.data?.theme?.secondary_colour, brand_logo: response?.data?.data?.theme?.url, brand_logo_download_url: response?.data?.data?.theme?.download_url}))
        //  dispatch(setGuestReviewState({event_details: , logs: , theme:}))
          }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          showSnackBar(dispatch, errorObject, ()=> dispatch(setGuestReviewState({show_guest_revision_page: false})));
          isLoader && dispatch(setGuestReviewState({is_loading: false}))
        }
        });
      }


      

  return { registerGuestUser, createDeviceInfo, getDeviceInfo};
}